const Contact = () => {
  return(
    <div style={{margin:"300px"}}>
      <h1>Contact</h1>
      <h3>work in progress</h3>
    </div>
  );
};

export default Contact;